<template>
    <div>
        <router-view v-show="$route.meta.hasOwnProperty('detail') && $route.meta.detail"></router-view>
        <div class="wrap" v-show="!$route.meta.hasOwnProperty('detail') || !$route.meta.detail">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ title }}
                            <el-button class="title_btn" type="primary" @click="save()">
                                등록
                            </el-button>
                            <div class="clear"></div>
                        </div>
                        <example-list-component :exampleType="'word'"></example-list-component>
                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExampleListComponent from "@/components/example/ExampleListComponent";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";

export default {
    name: "ExampleWord",
    mixins: [alertMixins],
    components: {ExampleListComponent},
    inject: [],
    provide() {
        return {
            setMaxExampleLength: this.setData
        }
    },
    props: {},
    data() {
        return {
            title: this.$route.meta.title,
            maxExampleLength: 0
        }
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {},
    computed: {},
    methods: {
        setData(type,value){
            this[type] = value
        },
        save(){
            EventBus.$emit('checkExampleDataLength')
            if(this.maxExampleLength >= 5){
                this.createAlert({
                content: '검색창 노출 문구 최대 등록 수를 초과했습니다.<br>삭제 후 등록해 주세요.<br>(현재 등록 수:5개)',
                    hide: () => {
                    }
                })
            } else {
              this.$router.push('example/create')
            }
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
